import { styled } from "styled-components";

export const DonutWrapper = styled.div`
	@media (max-width: 780px) {
		display: none;
	}
`;
